<template>
  <div :class="`comp-table-inner-edit ${fieldType == 25 ? 'table-inner-edit-association' : ''}`" v-if="data.editable" ref="tableInnerEditRef">
    <!-- 单选，下拉单选，多选，下拉多选 -->
    <template v-if="data.selectList.indexOf(fieldType) > -1">
      <ly-tag-fields :displayOneLine="displayOneLine" :isList="isList" :fieldValue="newFieldValue" :record="record" :fieldName="fieldName" :fieldKey="fieldKey" :styleInfo="fieldExt" :fieldType="fieldType" />
    </template>
    <!--其他支持编辑的字段类型  -->
    <template v-else>
      <!-- 人员 -->
      <template v-if="fieldType == 6">
        <template v-if="newFieldValue && newFieldValue?.length > 0">
          <ly-avatar :record="newFieldValue" :size="22"></ly-avatar>
        </template>
        <template v-else> - </template>
      </template>
      <!-- 日期 -->
      <template v-else-if="fieldType == 8">
        <template v-if="newFieldValue && fieldExt">
          {{ dayjs(newFieldValue).format(fieldExt) || '-' }}
        </template>
        <template v-else>{{ newFieldValue || '-' }} </template>
      </template>
      <!-- 超链接 -->
      <template v-else-if="fieldType == 11">
        <template v-if="newFieldValue">
          <jw-link :href="newFieldValue" target="_blank" style="color: rgb(var(--link-6))">{{ $t('查看') }}</jw-link>
          <!-- 腾讯官网定开需求 from xuedong start -->
          <jw-link v-if="entity == 228 && fieldKey == 'web_url'" style="color: rgb(var(--link-6))" @click.stop="copyLink">{{ $t('复制') }}</jw-link>
          <!-- 腾讯官网定开需求 from xuedong end -->
        </template>
        <template v-else> - </template>
      </template>
      <!-- 查找关联 -->
      <template v-else-if="fieldType == 12">
        <template v-if="newFieldValue">
          <template v-if="data.specialProduct.includes(Number(newFieldValue.business))">
            <span>{{ newFieldValue.label }}</span>
          </template>
          <ly-association :mask="mask" v-else :value="newFieldValue" :entity="newFieldValue?.business"></ly-association>
        </template>

        <template v-else>-</template>
      </template>
      <template v-else-if="fieldType == 25">
        <template v-if="newFieldValue?.length">
          <jw-overflow-list :min="1">
            <div v-for="fv in newFieldValue" :key="fv.value">
              <div :class="tools.getStrLen(fv.label) > 7 ? 'inner-edit-association' : ''">
                <ly-association :mask="mask" :value="fv" :entity="fv?.business"></ly-association>
              </div>
            </div>
            <template #overflow="{ number }">
              <jw-popover trigger="click" content-style="padding:0 2px 0 0">
                <template #content>
                  <div class="popover-content">
                    <jw-space direction="vertical" :size="4">
                      <template v-for="fv in newFieldValue" :key="fv.value">
                        <ly-association :mask="mask" :value="fv" :entity="fv?.business"></ly-association>
                      </template>
                    </jw-space>
                  </div>
                </template>
                <jw-tag class="hand" size="small">+{{ number }}</jw-tag>
              </jw-popover>
            </template>
          </jw-overflow-list>
        </template>
        <template v-else>-</template>
      </template>
      <!-- 部门 -->
      <template v-else-if="fieldType == 22">
        <template v-if="newFieldValue">
          <jw-tooltip content-class="jw-tooltip-scroll" :content-style="{ padding: '8px 6px 8px 12px' }">
            <template v-if="mainField && newFieldValue && isList">
              <jw-link class="ly-edit-fields-value">{{ newFieldValue }}</jw-link>
            </template>
            <template v-else>
              <template v-if="newFieldValue && isList">
                <div class="ly-edit-fields-value">{{ displayFieldsVal() }}</div>
              </template>
              <span class="textarea-show-formatting" v-else>{{ displayFieldsVal() }}</span>
            </template>
            <template #content>
              <div class="scope-wide-item-avatar">
                <jw-space direction="vertical" fill>
                  <div class="scope-wide-item-avatar-name" v-for="(item, index) in newFieldValue.split(',')" :key="index">
                    <jw-tag size="small" :color="getRandomColor(index)" :style="{ color: '#000', wordBreak: 'break-all', whiteSpace: 'normal', height: 'auto' }">{{ item }}</jw-tag>
                  </div>
                </jw-space>
              </div>
            </template>
          </jw-tooltip>
        </template>
        <template v-else>-</template>
      </template>
      <!-- 附件 -->
      <template v-else-if="fieldType == 18">
        <template v-if="newFieldValue">
          <ly-attachment-list :fieldValue="newFieldValue" :all="isList ? false : true"></ly-attachment-list>
        </template>
        <template v-else>-</template>
      </template>
      <!-- 富文本 -->
      <template v-else-if="fieldType == 26">
        <template v-if="newFieldValue">
          <ly-rich-text :fieldValue="newFieldValue" :isSingleLine="isList ? true : false"></ly-rich-text>
        </template>
        <template v-else>-</template>
      </template>
      <template v-else>
        <!-- 主属性 -->
        <template v-if="mainField && newFieldValue && isList">
          <jw-tooltip position="top" mini :content="newFieldValue" :content-style="{ borderRadius: '4px' }">
            <jw-link class="ly-edit-fields-value">{{ newFieldValue }}</jw-link>
          </jw-tooltip>
        </template>
        <template v-else>
          <jw-tooltip v-if="newFieldValue && isList" position="top" mini :content="newFieldValue" :content-style="{ borderRadius: '4px' }">
            <div class="ly-edit-fields-value">{{ displayFieldsVal() }}</div>
          </jw-tooltip>

          <span class="textarea-show-formatting" v-else>{{ displayFieldsVal() }}</span>
        </template>
      </template>
    </template>
    <!-- 线索池不能编辑 -->
    <!-- <template v-if="data.entity != 101"> -->
    <!-- 计算状态 1 当前数据状态不支持编辑 这种不能编辑(走审批且状态审批中/已生效) -->
    <template v-if="computingStatus.includes(Number(computedInfo?.status)) || (lockedOrigin && data.entity != 101) || (getFieldExtUploadType()?.uploadType == 2 && getFieldExtUploadType()?.fileType == 2)">
      <span class="table-inner-edit-icon" :uniqueValue="uniqueValue" @click.stop="">
        <jw-tooltip content="当前数据状态不支持编辑" :content-style="{ borderRadius: '4px' }"> <icon-pen-fill /> </jw-tooltip>
      </span>
    </template>
    <template v-else>
      <!-- EntityType 特殊处理 -->
      <template v-if="fieldKey != 'entityType' && fieldKey != 'businessId'">
        <template v-if="permissions && permissions == 1 && userInfo?.roles?.indexOf(data.permissionsObjList[data.entity]) !== -1">
          <span class="table-inner-edit-icon table-inner-edit-permissions" :uniqueValue="uniqueValue" @click.stop="clickEdit">
            <icon-pen-fill />
          </span>
        </template>
        <template v-else>
          <span class="table-inner-edit-icon" :uniqueValue="uniqueValue" @click.stop="">
            <jw-tooltip content="你没有权限编辑此字段" :content-style="{ borderRadius: '4px' }"> <icon-pen-fill /> </jw-tooltip>
          </span>
        </template>
      </template>
    </template>
    <!-- </template> -->
  </div>

  <template v-if="data.editContent">
    <!--不走行内编辑 -->
    <template v-if="data.NoLineEditable.indexOf(fieldType) > -1">
      <!-- 附件 -->
      <template v-if="fieldType === 18">
        <fh-upload-modal @cb="getNewFieldsVal" ref="uploadRef" opType="0" />
      </template>
      <!-- 人员 -->
      <template v-if="fieldType === 6">
        <xl-tree-member-modal :tree="personTree" :memberNumber="1" ref="xlTreeMember" :multipleDep="tools.isJSON(fieldExt) ? (JSON.parse(fieldExt)?.single == 1 ? false : true) : true" @cb="getMember($event)" :user="data.getOriginalValue.userList" @cancel="closeEdit">
          <jw-input-tag v-model="getEditFieldsObj.fieldValue" class="system-form-person-value" :max-tag-count="3" readonly placeholder="请选择" />
        </xl-tree-member-modal>
      </template>
      <!-- 部门-->
      <xl-tree-member-modal v-if="fieldType === 22" ref="xlTreeMember" :tree="departTree" :multipleDep="fieldExt == 1 ? false : true" :depart="data.getOriginalValue.departList" @cb="getMember($event)" @cancel="closeEdit">
        <jw-input-tag v-model="getEditFieldsObj.fieldValue" class="system-form-person-value" :max-tag-count="3" readonly placeholder="请选择" />
      </xl-tree-member-modal>
      <template v-if="fieldType === 26">
        <!-- 富文本 -->
        <ly-editor-dialog ref="editorDialogRef" @cb="handelEditorCb" :isRequired="isRequired"></ly-editor-dialog>
      </template>
    </template>
    <!-- 走行内编辑 -->
    <template v-else>
      <!-- 主列表 -->
      <teleport to="body" v-if="isList && !associationTable">
        <table-inner-edit-content :fieldInfo="fieldInfo" ref="tableInnerEditContentRef" @cb="getNewFieldsVal" @closeModal="closeModal" @cancelEdit="closeEdit" :editFieldsObj="getEditFieldsObj" :isList="isList" :associationTable="associationTable" />
      </teleport>
      <!-- 详情和关联对象表格 -->
      <template v-else>
        <table-inner-edit-content :fieldInfo="fieldInfo" ref="tableInnerEditContentRef" @cb="getNewFieldsVal" @closeModal="closeModal" @cancelEdit="closeEdit" :editFieldsObj="getEditFieldsObj" :isList="isList" :zIndex="data.zIndex" :associationTable="associationTable" />
      </template>
    </template>
  </template>
  <template v-if="data.showOverlay">
    <!-- 主列表 -->
    <teleport to="body" v-if="isList && !associationTable">
      <div class="overlay" @click.stop="hideLay"></div>
    </teleport>
    <!-- 详情及关联表格 -->
    <div v-else class="overlay" :style="{ zIndex: data.zIndex }" @click.stop="hideLay"></div>
  </template>
</template>

<script setup>
import { ref, reactive, nextTick, inject, watchEffect, computed } from 'vue';
import useViewFields from '@/hooks/view-fields';
import useEditFields from '@/hooks/edit-field';
import md5 from 'js-md5';
import CONFIG from '@/config/config';

import { useUserStore } from '@/store';
import { tools } from '@/utils/tools.js';
import dayjs from 'dayjs';
import { Message } from '@arco-design/web-vue';
import { useI18n } from 'vue-i18n';
import { computingStatus } from '@/utils/const';

const { getFieldValue, getFieldLabel } = useViewFields();
const { editField } = useEditFields();
const { t } = useI18n();
const emits = defineEmits(['cb']);
// console.log('组件重新加载了');
const props = defineProps({
  fieldName: {
    //字段名称
    type: String,
    default: ''
  },
  mainField: {
    //是否主属性字段
    type: Boolean,
    default: false
  },
  fieldType: {
    //字段类型
    type: String || Number,
    default: ''
  },
  fieldValue: {
    //字段的值(处理之后的)
    type: Object || String || Number,
    required: true
  },
  originalValue: {
    //字段的值(未处理之前)
    type: Object || String || Number,
    required: true
  },
  subEntityId: {
    //当条对象子表的EntityId
    type: String || Number,
    required: true
  },
  isSubForm: {
    //是否是子表
    type: Boolean,
    default: false
  },
  fieldKey: {
    //字段的fieldKey信息
    type: String,
    required: true
  },
  fieldExt: {
    //字段的fieldExt信息
    type: String || Number,
    required: true
  },
  uniqueValue: {
    //当前字段的唯一值
    type: String || Number,
    required: true
  },
  entity: {
    //当条对象entity id
    type: String || Number,
    required: true
  },
  businessId: {
    //当条数据的id
    type: String || Number,
    required: true
  },
  permissions: {
    //当前数据权限
    type: String || Number,
    required: true,
    default: ''
  },
  status: {
    //数据状态
    type: String || Number,
    required: true
  },
  lockedOrigin: {
    //是否锁定
    type: Boolean,
    default: false
  },
  isList: {
    // 是否是列表
    type: Boolean,
    default: false
  },
  mask: {
    // 详情弹窗是否有遮罩
    type: Boolean,
    default: false
  },
  associationTable: {
    // 是否是关联对象表格
    type: Boolean,
    default: false
  },
  isRequired: {
    // 字段是否必填
    type: Boolean,
    default: false
  },
  record: {
    // 数据项
    type: [Object],
    default: () => {
      return {};
    }
  },
  computedInfo: {
    // 计算状态
    type: [Object],
    default: () => {
      return {};
    }
  },
  displayOneLine: {
    //布局 0：1/2行  1：整行 2:1/3行 3:2/3行
    type: Number,
    default: 0
  },
  fieldInfo: {
    //字段信息 查找关联编辑拼module结构
    type: Object,
    default: () => {
      return {};
    }
  }
});
console.log(301, props.fieldValue, props.displayOneLine);
const data = reactive({
  refreshValue: inject('detailParams')?.refreshValue,
  entity: props?.entity || '',
  businessId: props?.businessId || '',
  columns: inject('globalParams')?.columns || inject('defaultParams')?.columns,
  noPermissions: false,
  editable: true, //编辑状态
  editContent: false, //编辑容器
  showOverlay: false, //蒙层
  specialProduct: [7, 9, 11, 14, 32], //特殊产品对象
  permissionsObjList: {
    //编辑权限
    1: 'clue:edit',
    2: 'customer:edit',
    3: 'businessOpportunity:edit',
    4: 'product:edit',
    6: 'priceSheet:edit',
    //   7: '报价单产品',
    8: 'contract:edit',
    //   9: '合同产品',
    10: 'saleOrder:edit',
    //   11: '订单产品',
    12: 'afterSale:edit',
    13: 'returnOrder:edit',
    16: 'dynamicRecord:edit',
    //   14: '退货单产品',
    //   32: '商机产品',
    101: 'cluePool:edit'
  },
  restricted: [1, 2, 3, 101, 6, 8, 10, 12],
  statusConditions: [1, 2, '1', '2'], //审批中 已生效,(详情个别对象返回的是字符串柳沛的锅)
  selectList: [2, 3, 4, 5], //单选多选
  numberList: [7, 23], //数字类型
  NoLineEditable: [6, 18, 22, 26], //不走行内编辑的字段类型
  getOriginalValue: {
    userList: [], //人员列表
    departList: [], //部门列表
    userIds: [], //人员ids
    departIds: [] //部门ids
  },
  zIndex: 1001 //默认是1001
});
const getFieldExtUploadType = () => {
  if (props.fieldExt && tools.isJSON(props.fieldExt) && JSON.parse(props.fieldExt)) {
    return JSON.parse(props.fieldExt);
  }
};
const getRandomColor = (index) => {
  const colors = ['#fce3e2', '#fce7cc', '#f8edc0', '#e3f09f', '#d3f5cd', '#c9f2ec', '#ceeffd', '#e1e9ff', '#fce2f2', '#eee6ff']; // 示例色值数组
  // const randomIndex = Math.floor(Math.random() * colors.length);
  const randomIndex = (index + 1) % colors.length;
  return colors[randomIndex - 1];
};
const getEditFieldsObj = ref({});
const computedInfo = computed(() => props.computedInfo);
const editorDialogRef = ref(null);
// console.log(117, data.entity,inject('globalParams'));
//兼容自定义
if (data.entity >= 200) {
  data.permissionsObjList[data.entity] = `${data.entity}:edit`;
}
const { userInfo } = useUserStore(); //用户信息
const tableInnerEditContentRef = ref(); //编辑内容分类组件
const newFieldValue = ref(props.fieldValue);
const newOriginalValue = ref(props.originalValue); //数据原值
console.log(408, newFieldValue.value, newOriginalValue.value);
watchEffect(() => {
  //查找关联不处理 自己前端拿值
  if (props.fieldType != 12 && props.fieldType != 25) {
    newFieldValue.value = props.fieldValue;
  }
});
// 人员组件参数
const personTree = ref({
  checkDepartment: false
});
//部门组件参数
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});
const storage = {
  getItem(key) {
    let v = localStorage.getItem(key);
    if (v !== 'null' && v !== undefined) {
      v = JSON.parse(v);
    }
    return v;
  }
};
const uuid = ref(inject('defaultParams')?.viewId);
const tableInnerEditRef = ref(null);
const getEditFieldValue = ref();
// const getEditFieldLabel = ref(props.fieldLabel);
// watch(
//   () => props.fieldLabel,
//   (newVal) => {
//     getEditFieldLabel.value = newVal;
//   }
// );
const setFieldExt = ref();
const getFieldExt = ref();
const uploadRef = ref(); //上传附件
const xlTreeMember = ref(); //人员//部门
// 是否展示时间
// const isShowTime = (ext) => {
//   if (ext?.includes('HH:mm') || ext?.includes('HH:mm:ss') || ext?.includes('hh:mm')) {
//     return true;
//   } else {
//     return false;
//   }
// };
const ids = ref();
const memberlist = ref();
// 人员/组件获取
const getMember = async (v) => {
  ids.value = props.fieldType === 6 ? v.userList?.map((u) => u.id)?.join(',') || '' : v.departList?.map((u) => u.id)?.join(',') || '';
  memberlist.value = props.fieldType === 6 ? v?.userList || [] : v?.departList || [];
  if (props.isRequired && memberlist.value?.length == 0) {
    //必填校验
    Message.warning('必填字段不能为空!');
    closeEdit();
    return;
  }
  saveVal();
  closeEdit();
};

const editorVal = ref('');
const handelEditorCb = async (val) => {
  if (val.type === 'ok') {
    editorVal.value = val.value;
    await saveVal();
    closeEdit();
  } else {
    getNewFieldsVal({ fieldValue: props.fieldValue });
    closeEdit();
  }
};
// 人员点击保存，富文本点击保存
const saveVal = async () => {
  const params = {
    // entity: data.entity,
    entity: props.isSubForm ? props.subEntityId : data.entity,
    fieldKey: props.fieldKey,
    businessId: data.businessId,
    // fieldValue: ids.value,
    apiIndex: data.entity + Math.random()
  };
  if (props.fieldType === 6 || props.fieldType === 22) {
    params.fieldValue = ids.value;
  }

  if (props.fieldType === 26) {
    // 富文本特殊处理
    params.fieldValue = editorVal.value;
  }

  await editField(params)
    .then((res) => {
      if (!res.error) {
        //编辑成功
        Message.success('保存成功');
        const setParams = { fieldValue: props.fieldType === 26 ? editorVal.value : memberlist.value };
        getNewFieldsVal({
          fieldValue: setParams.fieldValue,
          businessId: data.businessId
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
const clickEdit = () => {
  //点击编辑
  //   console.log('字段值', newFieldValue.value);
  //   console.log('字段原值', newOriginalValue.value);
  //   console.log('props.fieldType', props.fieldType);
  //   console.log('props.fieldExt', props.fieldExt);
  const getAditPopup = document.querySelectorAll('.obj-details-drawer');
  if (getAditPopup && getAditPopup?.length > 0) {
    data.zIndex = Number(getAditPopup[getAditPopup?.length - 1].style.zIndex) + 1;
  }
  if (props.fieldExt && tools.isJSON(props.fieldExt) && (data.selectList.indexOf(props.fieldType) > -1 || props.fieldType == 10)) {
    //把已经禁用的选项过滤掉
    setFieldExt.value = JSON.stringify(JSON.parse(props.fieldExt)?.filter((i) => i.isEnabled));
    getFieldExt.value = setFieldExt.value && tools.isJSON(setFieldExt.value) ? JSON.parse(setFieldExt.value) : [];
  }
  if (data.selectList.indexOf(props.fieldType) > -1 || props.fieldType == 10) {
    //多选,级联
    const editFieldValue = newFieldValue.value && getFieldValue(newFieldValue.value, props.fieldExt, props.fieldType); //根据字段的label获取value
    // console.log('editFieldValue---', editFieldValue);
    if (props.fieldType === 3 || props.fieldType === 5) {
      //多选/下拉多选特殊处理
      getEditFieldValue.value = (editFieldValue && editFieldValue?.split('/')) || [];
      const valuesInAa = new Set(getFieldExt.value?.map((item) => item.value)); //把value过滤出来
      const filteredBb = getEditFieldValue.value?.filter((value) => valuesInAa.has(value));
      getEditFieldValue.value = filteredBb && filteredBb?.length > 0 ? filteredBb : ''; //把在fieldExt里不存在的选项值清空
    } else if (props.fieldType === 2 || props.fieldType === 4) {
      //单选/下拉单选特殊处理
      getEditFieldValue.value = editFieldValue || '';
      const findOption = getFieldExt.value?.find((el) => el.value == getEditFieldValue.value);
      if (!findOption) {
        //在fieldExt里没有获取到把值清空
        getEditFieldValue.value = '';
      }
    } else {
      //级联
      getEditFieldValue.value = editFieldValue && typeof editFieldValue === 'string' ? editFieldValue?.split('/') : [];
    }
  } else if (props.fieldType == 8) {
    //日期
    if (newFieldValue.value) {
      // const fe = isShowTime(props?.fieldExt) ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
      getEditFieldValue.value = dayjs(newFieldValue.value).format(props?.fieldExt);
    } else {
      getEditFieldValue.value = '';
    }
  } else if (props.fieldType == 9) {
    //日期
    getEditFieldValue.value = newFieldValue.value && typeof newFieldValue.value === 'string' ? newFieldValue.value?.split('/') : [];
  } else if (data.numberList.indexOf(props.fieldType) > -1) {
    //数字类型的
    getEditFieldValue.value = !isNaN(parseFloat(newFieldValue.value)) ? Number(newFieldValue.value) : '';
  } else if (props.fieldType == 6) {
    newOriginalValue.value = newOriginalValue.value || props.originalValue; //获取最新数据原值
    //人员
    data.getOriginalValue.userList = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value.map((e) => ({ userName: e?.userName, id: e?.userId || e?.id, avatarOrigin: e?.avatar || e?.avatarOrigin })) : [];
    data.getOriginalValue.userIds = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((e) => e?.userId || e?.id) : '';
    getEditFieldValue.value = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((e) => e?.userName) : [];

    console.log('人员编辑333', props, newFieldValue.value, data.getOriginalValue.userList, data.getOriginalValue.userIds, getEditFieldValue.value);
  } else if (props.fieldType == 22) {
    newOriginalValue.value = newOriginalValue.value || props.originalValue; //获取最新数据原值
    //部门
    data.getOriginalValue.departList =
      newOriginalValue.value && Array.isArray(newOriginalValue.value)
        ? newOriginalValue.value?.map((u) => {
            return {
              departmentName: u?.name || u?.departmentName,
              id: u.id
            };
          })
        : [];
    data.getOriginalValue.departIds = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((u) => u.id) : '';
    getEditFieldValue.value = newOriginalValue.value && Array.isArray(newOriginalValue.value) ? newOriginalValue.value?.map((u) => u?.name || u?.departmentName) : [];
  } else if (props.fieldType == 16) {
    //金额
    getEditFieldValue.value = !isNaN(parseFloat(newOriginalValue.value)) ? tools.getPrice(newOriginalValue.value, props.fieldExt) : '';
  } else {
    //其他类型
    getEditFieldValue.value = newFieldValue.value || '';
  }
  const rect = tableInnerEditRef.value?.getBoundingClientRect();
  let newWidth;
  if (props.isList && props.associationTable) {
    //关联对象表格
    newWidth = data?.columns?.find((el) => el.colKey == props.fieldKey)?.width;
  }
  if (props.isList && !props.associationTable) {
    //主列表
    const uniqueKey = data?.columns?.map((el) => el.colKey).join('') + data?.columns?.length;
    // 保存默认列和实际列
    const tableKey = `${CONFIG.prefix}TABLE_COLS_${uuid.value}_${md5(uniqueKey)}`;
    const kf = storage.getItem(tableKey);
    newWidth = kf?.k?.[props.fieldKey]?.width;
  }

  getEditFieldsObj.value = {
    //保存字段信息
    entity: data.entity,
    subEntityId: props.subEntityId,
    isSubForm: props.isSubForm,
    fieldKey: props.fieldKey,
    fieldType: props.fieldType,
    fieldExt: data.selectList.indexOf(props.fieldType) > -1 ? setFieldExt.value : props.fieldExt,
    fieldName: props.fieldName,
    fieldValue: getEditFieldValue.value,
    businessId: data.businessId,
    isRequired: props.isRequired,
    top: rect.top + window.scrollY - 4 + 'px',
    left: rect.left + window.scrollX - 6 + 'px',
    width: newWidth - 24 + 'px'
  };
  data.editable = false;
  data.editContent = true;
  if (data.NoLineEditable.indexOf(props.fieldType) == -1) {
    //走行内编辑的字段类型
    data.showOverlay = true;
    nextTick(() => {
      tableInnerEditContentRef.value?.processing(); //对一些字段的默认处理
    });
  }
  nextTick(() => {
    if (props.fieldType == 18) uploadRef.value?.openModal(getEditFieldsObj.value); //编辑附件弹窗
    if (props.fieldType == 6 || props.fieldType == 22) xlTreeMember.value?.openDialog(); //人员组件
    if (props.fieldType == 26) editorDialogRef.value?.openDialog(getEditFieldsObj.value);
  });
};
// 处理展示的值 给个别字段加单位
const displayFieldsVal = () => {
  let getFieldVal = newFieldValue.value;
  // console.log(598, getFieldVal);
  if (props.fieldType == 23 && !isNaN(parseFloat(getFieldVal))) {
    getFieldVal = getFieldVal + '%';
  } else if (props.fieldType == 7 && !isNaN(parseFloat(getFieldVal))) {
    const getFieldExt = tools.isJSON(props.fieldExt) && JSON.parse(props.fieldExt);
    getFieldVal = tools.getNumberShow(getFieldVal, props.fieldExt) + (getFieldExt?.numberUnit ? getFieldExt.numberUnit : '');
  } else if (props.fieldType == 16 && !isNaN(parseFloat(getFieldVal))) {
    const getFieldExt = tools.isJSON(props.fieldExt) && JSON.parse(props.fieldExt);
    getFieldVal = getFieldVal + (getFieldExt?.numberUnit ? getFieldExt.numberUnit : '');
  }
  return getFieldVal || '-';
};
// 获取修改之后的值
const getNewFieldsVal = (cbParams) => {
  console.log('更新之后的值，', cbParams);
  //保存人员、部门选择的原值
  if (props.fieldType == 6 || props.fieldType == 22 || props.fieldType == 16 || props.fieldType == 12 || props.fieldType == 25) {
    newOriginalValue.value = cbParams.fieldValue;
  }
  //只有列表处理-日期
  if (props.fieldType == 9) {
    if (Array.isArray(cbParams.fieldValue)) {
      newFieldValue.value = cbParams.fieldValue?.length ? cbParams.fieldValue?.join('/') : '';
    } else if (tools.isJSON(cbParams.fieldValue)) {
      newFieldValue.value = Object.prototype.toString.call(JSON.parse(cbParams.fieldValue)) === '[object Object]' ? Object.values(JSON.parse(cbParams.fieldValue))?.join('/') : '';
    }
    console.log(620, newFieldValue.value);
  }
  //处理-金额
  else if (props.fieldType == 16) {
    newFieldValue.value = !isNaN(parseFloat(cbParams.fieldValue)) ? tools.getPriceShow(cbParams.fieldValue, props.fieldExt) : '';
  }
  // 仅有详情处理百分比
  else if (props.fieldType == 23) {
    if (props.isList) {
      newFieldValue.value = !isNaN(parseFloat(cbParams.fieldValue)) ? cbParams.fieldValue.toFixed(Number(JSON.parse(props.fieldExt)?.numberFormat) ?? 2) : '';
    } else {
      newFieldValue.value = !isNaN(parseFloat(cbParams.fieldValue)) ? tools.getPercentage(cbParams.fieldValue).toFixed(Number(JSON.parse(props.fieldExt)?.numberFormat) ?? 2) : '';
    }
  }
  // 列表和详情都要处理的逻辑（单选，多选，级联）
  else if (data.selectList.includes(props.fieldType) || props.fieldType == 10) {
    const tempFields = getFieldLabel(cbParams.fieldValue, props.fieldExt, props.fieldType);
    // console.log('tempFields---',tempFields)
    if (props.fieldType == 2 || props.fieldType == 4) {
      //单选，下拉单选
      newFieldValue.value = tempFields ?? '';
    }
    if (props.fieldType == 3 || props.fieldType == 5) {
      //下拉多选，多选
      newFieldValue.value = Array.isArray(cbParams.fieldValue) && cbParams.fieldValue?.length > 0 ? tempFields?.split('/')?.join(',') : '';
    }
    if (props.fieldType == 10) {
      //级联
      newFieldValue.value = Array.isArray(cbParams.fieldValue) && cbParams.fieldValue?.length > 0 ? tempFields : '';
    }
  } else if (props.fieldType == 8) {
    //日期
    if (cbParams.fieldValue) {
      const fe = props.fieldExt ? props.fieldExt : cbParams.fieldValue?.split(' ')?.length > 1 ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD';
      newFieldValue.value = dayjs(cbParams.fieldValue).format(fe);
    } else {
      newFieldValue.value = '';
    }
  } else if (props.fieldType === 6) {
    newFieldValue.value =
      cbParams.fieldValue && Array.isArray(cbParams.fieldValue)
        ? cbParams.fieldValue?.map((u) => {
            return {
              avatar: u?.avatarOrigin,
              userId: u?.id,
              userName: u?.userName
            };
          })
        : [];
  } else if (props.fieldType === 22) {
    newFieldValue.value =
      (cbParams?.fieldValue &&
        Array.isArray(cbParams?.fieldValue) &&
        cbParams.fieldValue
          ?.map((i) => {
            return i.departmentName;
          })
          .join(',')) ||
      '';
  } else {
    newFieldValue.value = cbParams.fieldValue;
  }
  emits('cb', { ...cbParams, fieldValue: newFieldValue.value, businessId: props.businessId, fieldKey: props.fieldKey });
  console.log('处理之后的值，', newFieldValue.value);
  closeEdit();
  if (!props.isList && data?.refreshValue) {
    //详情刷新重复的字段值
    let refreshVal = cbParams.fieldValue;
    if (data.selectList.includes(props.fieldType) || props.fieldType == 10) {
      refreshVal = newFieldValue.value;
    }
    data?.refreshValue(refreshVal, props.fieldKey);
  }
};
// 隐藏遮罩
const closeModal = async () => {
  data.showOverlay = false;
};
// 关闭编辑状态
const closeEdit = () => {
  data.editContent = false;
  data.editable = true;
};
// 点击遮罩
const hideLay = async () => {
  await tableInnerEditContentRef.value?.editSave();
  closeEdit();
};
// 复制网址
const copyLink = async () => {
  try {
    await navigator.clipboard.writeText(newFieldValue.value);
    Message.success(t('复制成功'));
  } catch (err) {
    Message.error(t('复制失败'));
    console.log('复制失败', err);
  }
};
</script>
<style scoped lang="less">
@import './table-inner-edit.less';
</style>
